import React, { useEffect, useState, useCallback } from 'react';
import { Badge, Popover, List, Typography, Tag, Button, Empty, Space, Divider } from 'antd';
import { BellOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { fetchNotifications } from '../services/callService';
import { TYPE_COLORS } from './callConstants';

const { Text } = Typography;

// Header bell: polls the call module for due/overdue follow-ups.
const NotificationBell = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({ counts: {}, total: 0, items: [] });
  const [open, setOpen] = useState(false);

  const load = useCallback(async () => {
    try { setData(await fetchNotifications()); } catch { /* ignore */ }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 60000); // refresh every minute
    return () => clearInterval(t);
  }, [load]);

  const c = data.counts || {};
  const summary = [
    { label: "Today", value: c.today, to: '/calls/today' },
    { label: 'Overdue', value: c.overdue, to: '/calls/overdue' },
    { label: 'Upcoming', value: c.upcoming, to: '/calls/upcoming' },
    { label: 'Site Visit Today', value: c.siteVisitToday, to: '/calls/today' },
    { label: 'Quotation', value: c.quotation, to: '/calls/upcoming' },
    { label: 'Missed', value: c.missed, to: '/calls/missed' },
  ].filter(s => Number(s.value) > 0);

  const go = (to) => { setOpen(false); navigate(to); };

  const content = (
    <div style={{ width: 320 }}>
      <Space wrap style={{ marginBottom: 8 }}>
        {summary.length === 0 ? <Text type="secondary">All caught up 🎉</Text>
          : summary.map(s => (
            <Tag key={s.label} color="blue" style={{ cursor: 'pointer' }} onClick={() => go(s.to)}>
              {s.label}: {s.value}
            </Tag>
          ))}
      </Space>
      <Divider style={{ margin: '8px 0' }} />
      {(data.items || []).length === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No due follow-ups" />
      ) : (
        <List
          size="small"
          dataSource={data.items}
          renderItem={(it) => (
            <List.Item style={{ cursor: 'pointer' }} onClick={() => go('/calls/today')}>
              <List.Item.Meta
                title={<Text>{it.CustomerName} {it.FollowupType && <Tag color={TYPE_COLORS[it.FollowupType] || 'blue'}>{it.FollowupType}</Tag>}</Text>}
                description={<Text type="secondary" style={{ fontSize: 12 }}><ClockCircleOutlined /> {it.ScheduledAt ? dayjs(it.ScheduledAt).format('DD MMM, hh:mm A') : ''}</Text>}
              />
            </List.Item>
          )}
        />
      )}
      <Divider style={{ margin: '8px 0' }} />
      <Button type="link" block onClick={() => go('/calls')}>Open Call Dashboard</Button>
    </div>
  );

  return (
    <Popover content={content} title="Notifications" trigger="click" open={open} onOpenChange={setOpen} placement="bottomRight">
      <Badge count={data.total || 0} size="small" offset={[-2, 2]}>
        <Button type="text" icon={<BellOutlined style={{ fontSize: 18 }} />} />
      </Badge>
    </Popover>
  );
};

export default NotificationBell;
